import React from "react";
import cn from "classnames";
import "./FocusBoxWithLabels.less";
import FocusBox from "../FocusBox";

interface Props {
    content: {
        upperLeft: {
            title: string;
            description?: string;
        };
        bottomRight: {
            title: string;
            description?: string;
        };
        bottomLeft: {
            title: string;
            description?: string;
        };
        upperRight: {
            title: string;
            description?: string;
        };
    };
    padding?: boolean;
}

const FocusBoxWithLabels: React.FC<Props> = ({ content, padding = true }) => {
    const { upperLeft, bottomRight, bottomLeft, upperRight } = content;

    return (
        <FocusBox className="focus-box-with-labels">
            <div className="focus-box-with-labels__inner">
                <div
                    className={cn("focus-box-with-labels__upper-left", "focus-box-with-labels__item", {
                        "focus-box-with-labels__upper-left--padding": padding,
                        "focus-box-with-labels__upper-left--border": true,
                    })}
                >
                    <div className="item-title">{upperLeft.title}</div>
                    <span className="item-description item-description--bold">{upperLeft.description}</span>
                </div>
                <div
                    className={cn("focus-box-with-labels__upper-right", "focus-box-with-labels__item", {
                        "focus-box-with-labels__upper-right--padding": padding,
                        "focus-box-with-labels__upper-right--border": true,
                    })}
                >
                    <div className="item-title">{upperRight.title}</div>
                    <span className="item-description">{upperRight.description}</span>
                </div>
                <div
                    className={cn("focus-box-with-labels__bottom-left", "focus-box-with-labels__item", {
                        "focus-box-with-labels__bottom-left--padding": padding,
                        "focus-box-with-labels__bottom-left--border": true,
                    })}
                >
                    <div className="item-title">{bottomLeft.title}</div>
                    <span className="item-description">{bottomLeft.description}</span>
                </div>
                <div
                    className={cn("focus-box-with-labels__bottom-right", "focus-box-with-labels__item", {
                        "focus-box-with-labels__bottom-right--padding": padding,
                        "focus-box-with-labels__bottom-right--border": true,
                    })}
                >
                    <div className="item-title">{bottomRight.title}</div>
                    <span className="item-description item-description--bold">{bottomRight.description}</span>
                </div>
            </div>
        </FocusBox>
    );
};

export default FocusBoxWithLabels;
